import getFromCdn from '@anm/helpers/getFromCdn';
import isUrlAbsolute from '@anm/helpers/is/isUrlAbsolute'; // TODO: add tests for helpers below

export var getFallback = function getFallback(src) {
  return src.replace(/_([^_]*).webp$/, ".$1");
};
export var getSrc = function getSrc(url) {
  return isUrlAbsolute(url) ? url : getFromCdn(url);
};
export var getFallBackUrl = function getFallBackUrl(src) {
  var webpFallback = getFallback(src);
  return getSrc(webpFallback);
};
export var isWebp = function isWebp(src) {
  return new RegExp('.webp').test(src);
};
export var getSafeImageUrl = function getSafeImageUrl(src) {
  return isWebp(src) ? getFallback(src) : getSrc(src);
};
export var fetchImage = function fetchImage(src) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.src = src;
    image.onload = resolve;
    image.onerror = reject;
  });
};